export const sxConfig = {
  container: {
    backgroundColor: '#E9F5FE',
    px: 3,
    pt: 2,
    minHeight: 'calc(100vh - 65px)',
  },

  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 3,
    justifyContent: 'center',
  },

  contentBox: {
    border: '4px solid #6cb2ee',
    height: 200,
    width: 350,
    backgroundColor: '#C3E1FB',
    color: '#6cb2ee',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: 2,
    textAlign: 'center',
    borderRadius: 5,
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#A7D6FF',
      transform: 'translateY(-4px) scale(1.1)',
    },
  },

  contextText: {
    fontSize: 24,
    mb: 1,
  },
};
